import { render, staticRenderFns } from "./CardSpotlightDocument.vue?vue&type=template&id=2879bd3c&"
import script from "./CardSpotlightDocument.vue?vue&type=script&lang=js&"
export * from "./CardSpotlightDocument.vue?vue&type=script&lang=js&"
import style0 from "./CardSpotlightDocument.vue?vue&type=style&index=0&id=2879bd3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports